import { FormBlock, Toggle } from '@qbe/ads-blocks-forms';
import { ToggleProps, Typography } from '@qbe/ads-core';
import { LIABILITY_LIMIT_OPTIONS } from 'constants/domain-specific';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useAppContent } from '~/hooks';
import { useTrackOptimizeActivate } from '~/hooks/useTrackOptimizeActivate';
import { LiabilityForm } from '~/steps/CoverDetailsLiability/types';

import { ContextualHelpWithButton } from '../../components-ds/ContextualHelp/ContextualHelpWithButton';

const Liability: React.FC = () => {
  const { getTextContent, getJSXContent } = useAppContent({
    basePath: 'dsme.coverDetailsBusinessLiability',
  });

  const { control } = useFormContext<Pick<LiabilityForm, 'liabilityLimit'>>();

  // Tracks the "optimize.activate" event when the component mounts or re-renders.
  // This is used to notify Webtrends (or other analytics tools) for visibility tracking
  // and ensures dynamic content is properly handled.
  useTrackOptimizeActivate();

  return (
    <FormBlock preset="toggle">
      <Controller
        render={({ field }) => (
          <Toggle
            {...field}
            optionList={LIABILITY_LIMIT_OPTIONS.map(
              ({ text, value: v }): ToggleProps['optionList'][number] => ({
                id: `limit-of-liability_${text}`,
                label: text,
                value: v.toString(),
                defaultChecked: field.value === v,
              })
            )}
            title={getTextContent('fields.selectLimitOfLiability.title')}
            titleSuffix={
              <ContextualHelpWithButton tracking="help: Limit of liability">
                <Typography>
                  {getJSXContent('contextualhelpers.selectLimitOfLiability.description')}
                </Typography>
              </ContextualHelpWithButton>
            }
            data-track="limit of liability"
            data-track-value="capture"
            helperText={getTextContent('fields.selectLimitOfLiability.helperText')}
          />
        )}
        name="liabilityLimit"
        control={control}
        rules={{ required: true }}
      />
    </FormBlock>
  );
};

export default Liability;
